// extracted by mini-css-extract-plugin
export default {"vmvDescription":"VMVDescription_vmvDescription__qXu1t"};